import { createContext, useContext } from 'react'

export type NavBadgeContextValue = {
  badgesByNavId: Record<string, number>
}

export const NavBadgeContext = createContext<NavBadgeContextValue>({
  badgesByNavId: {},
})

export function useNavBadges(): Record<string, number> {
  return useContext(NavBadgeContext).badgesByNavId
}
